/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import { Modal } from 'antd-mobile'
import * as _ from 'lodash'
//img
import GoEventBtnImg from '@assets/images/btn/anniversary-btn.png'
// css
import styled from '@themes/theme'
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import PaymentRewardEvent from './PaymentRewardEvent/index'
import { REWARD_COMPLETE_POPUP_TYPE, RewardCompletePopup } from '@views/Popup/Event/RewardComplete'
import { showToast, TOAST_TYPE } from '@utils/utils'
import { getErrorText } from '@game/errtext'
import Login from '@views/Login'
import { BannerButton } from 'containers/views/Popup/MatchupBanner/BannerButton'

export const AdvNewsWrap = styled.div`
  width: 100%;
  height: auto;
  max-height: 100%;
  overflow: auto;
  background: ${props => props.theme.color.contentsBg};

  .img {
    width: inherit;
  }

  .link {
    position: relative;
    bottom: 65px;
    left: 10px;
    display: block;
    width: 320px;
    height: 45px;
  }

  .event-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    border-radius: 0;

    img {
      width: inherit;
      height: auto;
    }
  }

  .anniversary-btn {
    position: sticky;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: auto;
    margin-top: -87px;
    background: none;
    border-radius: 0;

    &--img {
      width: 100%;
      height: auto;
    }
  }
`

const MatchupBannerPopup: React.FC = () => {
  const { globalStore, componentStore, authStore } = useRootStore()
  const { visibleMatchupBanner } = globalStore

  if (_.isEmpty(componentStore?.selectedGameBanner)) {
    return <Fragment/>
  }

  const { id, contentsImageUrl, buttonImageUrl, order, buttons } = componentStore.selectedGameBanner
  const isBannerButton = !_.isEmpty(buttons)

  const doCloseMessage = () => {
    globalStore.setVisibleMatchupBanner(false)
  }

  const onClickAnniversaryLinkAnchor = () => {
    // 승부예측 이벤트 링크
    const link = 'http://naver.me/5oQBuzwi'
    globalStore.toMoveWebHomePage(link, 'popup')
  }

  const showRewardCompletePopup = (rewardItem) => {
      globalStore.pushDialogOk({
        custom: <RewardCompletePopup popupType={REWARD_COMPLETE_POPUP_TYPE.LIVE_BET_EVENT}
                                     item={rewardItem}/>,
        className: 'middle-size box-type',
        positivePress: '확인',
        callbackPositive: () => {
          globalStore.closeDialog()
        },
        // 뒷배경 클릭 시 닫히도록
        callbackCloseDialogBg: () => {
          globalStore.closeDialog()
        },
      })
  }

  const onClickEventBannerBtn = async () => {
    try {
      if (!authStore.isSignedIn) {
        authStore.showLoginPopup(<Login/>)
        return
      }

      const result = await componentStore.api.component.receiveDailyBettingEventReward({ bannerId: id })
      const { rewardItem, errcode } = result
      if (_.isNil(errcode)) {
        showRewardCompletePopup(rewardItem)
        return
      }

      showToast(TOAST_TYPE.INFO, getErrorText(errcode))
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        visible={visibleMatchupBanner}
        animated={isMobile}
        animationType="slide-up"
        wrapClassName="sider-modal"
        title={
          <Fragment>
            <h1 className="title">승부사 소식</h1>
            <Button onClick={doCloseMessage} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal message"
        onClose={doCloseMessage}
      >
        <AdvNewsWrap>
          {contentsImageUrl && (
            <img src={contentsImageUrl} alt="승부사 소식" className="img"/>
          )}

          {/* 참여형 이벤트 하단버튼 */}
          {buttonImageUrl && (
            <Button TP className="event-btn" onClick={onClickEventBannerBtn}>
              <img src={buttonImageUrl} alt="참여형 이벤트 버튼"/>
            </Button>
          )}

          {/* 2주년 이벤트 플로팅 버튼 */}
          {order === 3 && <PaymentRewardEvent/>}
          {order === 5 &&
            <Button className="anniversary-btn" onClick={onClickAnniversaryLinkAnchor}>
              <img src={GoEventBtnImg} alt="축하영상도 보고 이벤트 참여하러 가기" className="anniversary-btn--img"/>
            </Button>
          }

          {/* 링크연결 - 다운로드 링크버튼 */}
          {isBannerButton && (
            <BannerButton bannerButtonData={buttons}/>
          )}
        </AdvNewsWrap>

        {!isMobile && <ModalBg/>}
      </Modal>
    </Fragment>
  )
}
export default observer(MatchupBannerPopup)
